@if (!AccessAllowed && CompletedLoading) {
  <div>
    <h3 style="border: 2px solid;border-radius: 6px;position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);padding: 10px;">You don't have access to this function</h3>
  </div>
}

@if (pageReady && AccessAllowed) {
  <div class="p-3 flex flex-column flex-auto cf-page" [class.cf-compact]="isMobile">
    <div>
      <div class="text-900 font-medium text-xl mb-3"><h3>Resource Group
      </h3></div>
      <p class="m-0 mb-4 p-0 text-600 line-height-3 mr-3">
        <span class="pi pi-info-circle" style="margin-right:2px;"></span>
        Give the resource group a name and then add the resources that make up the resource group.
      </p>
      <div class="surface-card p-4 shadow-2 border-round">
        <div class="grid formgrid p-fluid">
          <!-- <app-tabview style="width:100%">
          <app-tabpanel header="Resource Group Details" leftIcon="pi pi-clone"> -->
            <div class="field mb-4 col-12">
              <label for="classname" class="font-medium">Resource Group Name</label>
              <input [(ngModel)]="resourcegroupname.name" id="classname" type="text" [ngStyle]="{'border-color': (rgnNameValid==false) ? '#FF0000':''}" (keyup)="DoValidCheck()" pInputText>
            </div>
            @if (!rgnNameValid) {
              <div class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must enter a Resource Group Name.</div>
            }
            <div class="field mb-4 col-12">
              <label for="cansplit" class="font-medium">Multi-resource - this resource group will allocate multiple resources based on the group size.  If the group is too large to fit in resource 1 then it will allocate resource 1 and resource 2.  The system will keep allocating resources until everyone in the group is accommodated.</label>
              <p-selectbutton id="cansplit" [style]="{'width': '150px'}" [options]="stateOptionsRes" [(ngModel)]="resourcegroupname.cansplit" ></p-selectbutton>
            </div>
            <!-- Whether the group is on the Daysheet, and where, is set on the Daysheet Resource
            Order page, along with every other resource and group. The saved values still go back
            unchanged on save. -->
            <div class="field mb-4 col-12">
              <label class="font-medium">Day Sheet and Itinerary</label>
              <small class="block" style="color:#6c757d;">Whether this resource group appears on the Day Sheet and the Itinerary, and where, is set on the <a routerLink="/daysheetresourceorder">Daysheet Resource Order</a> page.</small>
            </div>
            <!--<div class="field mb-4 col-12">
            <label for="classname" class="font-medium">Quantity Label</label>
            <input [(ngModel)]="resourcegroupname.quantityLabel" id="classname" type="text" [ngStyle]="{'border-color': (rgnQLabelValid==false) ? '#FF0000':''}" (keyup)="DoValidCheck()" pInputText>
          </div>
          <div *ngIf="!rgnQLabelValid" class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must enter a Quantity Label.</div>-->
        <!-- </app-tabpanel>
        <app-tabpanel header="Group Resources" leftIcon="pi pi-sitemap"> -->
          <div class="surface-card p-4 shadow-2 border-round" style="width:100%;float:left;">
            @if (!isMobile) {
              <div style="float:left; width:32%">
                <div class="drag-column">
                  <h5> Available Resources </h5>
                  <p-table [value]="availableResources">
                    <ng-template #header>
                      <tr>
                        <th>Name</th>
                        <th>&nbsp;</th>
                      </tr>
                    </ng-template>
                    <ng-template #body let-resource>
                      <tr>
                        <td>{{resource.name}}</td>
                        <td>
                          <button pButton pRipple type="button" class="p-button-sm p-element p-button-success w-auto mt-3" (click)="AddToResources(resource)">
                            <span class="pi pi-angle-right"></span>
                          </button>
                        </td>
                      </tr>
                    </ng-template>
                  </p-table>
                  <!--<div *ngIf="availableResources.length == 0" style="padding: 15px;">
                  <i>No resources available</i>
                </div>-->
              </div>
            </div>
          }
          <div class="cf-col" style="float:right; width:65%">
            <div class="drop-column">
              <!-- On a phone the Available list is this dropdown instead - see addPicked. -->
              @if (isMobile) {
                <div class="cf-add-row">
                  <p-select [options]="availableResources" [(ngModel)]="picked['resources']" [ngModelOptions]="{standalone: true}" optionLabel="name" placeholder="Add a resource"
                  [filter]="true" filterBy="name" appendTo="body" emptyMessage="None available"></p-select>
                  <button pButton pRipple type="button" class="p-button-success"
                    [disabled]="picked['resources'] == null" (click)="addPicked('resources', AddToResources)"><span class="p-button-icon p-button-icon-left pi pi-plus" aria-hidden="true"></span><span class="p-button-label">Add</span></button>
                  </div>
                }
                <h5> Selected Resources </h5>
                <p-table [value]="resourcegroupname.resources">
                  <ng-template #header let-columns>
                    <tr>
                      <th style="width:90%">Name</th>
                      <th>&nbsp;</th>
                    </tr>
                  </ng-template>
                  <ng-template #body let-resource let-columns="columns" let-index="rowIndex">
                    <tr>
                      <td>{{resource.name}}</td>
                      <td>
                        <button pButton pRipple type="button" [style]="{'margin-bottom': '-6px', 'margin-top': '-4px !important'}" class="p-button-sm p-element p-button-danger w-auto mt-3" (click)="removeFromResources(resource)">
                          <span class="pi pi-angle-left"></span>
                        </button>
                      </td>
                    </tr>
                  </ng-template>
                </p-table>
                <!---<div *ngIf="selectedResources" style="padding: 15px;">
                <i>No resources selected, drag some here.</i>
              </div>-->
            </div>
          </div>
        </div>
      <!-- </app-tabpanel>
    </app-tabview> -->
    <div class="col-12">
      <button pButton pRipple type="button" class="p-button p-element p-button-success w-auto mt-3" (click)="updateData();">
        <span class="pi pi-pencil" style="margin-right:8px;"></span>
      Save Changes</button>
      &nbsp;
      <button pButton pRipple type="button" class="p-button p-element p-button-danger w-auto mt-3" (click)="returnToList()">
        <span class="pi pi-times" style="margin-right:8px;"></span>
      Cancel</button>
    </div>
  </div>
</div>
</div>
</div>
}